// custom component (not registry-generated)
import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as PageContainer } from './PageContainer.vue'

// The page-level layout wrapper — a centred, max-width, guttered column. Absorbs
// three KUI layout primitives into one recipe (foundation audit, family
// `page-container`):
//   • KUIUnifiedLayoutContainer — max-width column + gutter (the `size`+`gutter` axes)
//   • KUICoreContainer — `container mx-auto` + padding (folds into `size`+`gutter`)
//   • KUICoreContainerCentered — full-height flex centring (the `center` axis)
//
// Research (2026-07-21): the KUI trio exposes only max-width, gutter and a
// centre/direction toggle between them; reference DS APIs agree on the tight
// surface — Radix Themes `Container` (a `size` max-width scale), Nuxt UI
// `UContainer` (max-w + mx-auto + responsive px). So three orthogonal axes:
//   • `size`  — the max-width tier (mx-auto centres the column horizontally).
//   • `gutter`— responsive horizontal padding (KUI's `px-4`), on by default.
//   • `center`— the ContainerCentered role: fill the parent's height and centre
//               a column of content (splash / empty / loading states). Composes
//               with `size` (a centred, width-capped card) or `size="full"` for
//               the raw centring box. Row layouts add `class="flex-row"`.
// Widths use the stock Tailwind `max-w-*` scale (KUI's own `max-w-4xl`/`5xl`);
// no arbitrary values.
export const pageContainerVariants = cva(
  'w-full mx-auto',
  {
    variants: {
      size: {
        prose: 'max-w-prose',
        sm: 'max-w-2xl',
        md: 'max-w-4xl',
        lg: 'max-w-5xl',
        xl: 'max-w-7xl',
        full: 'max-w-none',
      },
      gutter: {
        true: 'px-4 sm:px-6',
        false: '',
      },
      center: {
        true: 'flex h-full flex-1 flex-col items-center justify-center',
        false: '',
      },
    },
    defaultVariants: {
      size: 'lg',
      gutter: true,
      center: false,
    },
  },
)
export type PageContainerVariants = VariantProps<typeof pageContainerVariants>
